import { gql } from '@apollo/client';
import list from './List';
import create from './Create';
import show from './Show';

export default {
  name: 'AccountLocations',
  inputShow: gql`
    query accountLocations($input: AccountLocationQueryInput) {
      accountLocations(input: $input) {
        id
        __typename
      }
    }
  `,
  list,
  show,
  create,
  options: {
    group: 'Misc',
    label: 'Account Locations',
  },
};
